import { memo, useMemo } from 'react';
import { FormAsyncSelectAutocompleteField } from '@dfl/mui-react-common';
import { IDriver } from '../../interfaces';
import { Checkbox } from '@mui/material';
import { DriverService } from '../../services';
import { CARRIER_DRIVERS_LIST_KEY } from '../../constants';
import { isOptionEqualToValue } from 'utils/comparing';
import { getFullName } from 'utils/index';
import { TermFilter } from '@dofleini/query-builder';

type DriverSelectProps = {
  name: string;
  required?: boolean;
  label?: string;
  placeholder?: string;
  helperText?: string;
  value?: string;
  onChange?: any;
  setValue?: any;
  control?: any;
  multiple?: boolean;
  carrierId?: string | null;
  defaultValue?: any;
};

const renderLabel = (option: IDriver) => getFullName(option?.firstName, option?.lastName) || '';

const renderOption = (props: any, option: IDriver, { selected }: any) => {
  return (
    <li {...props} key={option?._id as string}>
      <Checkbox style={{ marginRight: 8 }} checked={selected} />
      {getFullName(option?.firstName, option?.lastName)}
    </li>
  );
};

const DriverSelect = ({ name, defaultValue, carrierId, required, multiple, label, placeholder, helperText, control, onChange, setValue, ...props }: DriverSelectProps) => {
  const filters = useMemo(
    () =>
      new TermFilter({
        field: 'carrier',
        value: carrierId,
        objectId: true,
      }).toQuery(),
    [carrierId]
  );

  return (
    <FormAsyncSelectAutocompleteField
      multiple={multiple}
      required={required}
      label={label}
      disabled={!carrierId}
      name={name}
      fetchOption={{ filters }}
      sx={{ cursor: 'pointer' }}
      disableCloseOnSelect={multiple}
      fetchFunc={DriverService.search}
      queryKey={`[${CARRIER_DRIVERS_LIST_KEY}, ${carrierId as string}]`}
      autoHighlight
      isOptionEqualToValue={isOptionEqualToValue}
      fieldValue={'_id'}
      loadValue
      fetchValueFunc={multiple ? DriverService.search : DriverService.getOne}
      id={`select-driver-${carrierId as string}`}
      getOptionLabel={renderLabel}
      renderOption={renderOption}
      helperText={helperText}
    />
  );
};

export default memo(DriverSelect);
